import { useEffect } from 'react';
import { Outlet, useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGS } from '../i18n';

const HREFLANG_MAP = { en: 'en', ru: 'ru', ee: 'et' };

const LanguageLayout = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!SUPPORTED_LANGS.includes(lang)) {
      navigate('/en', { replace: true });
      return;
    }
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    document.documentElement.lang = HREFLANG_MAP[lang] || lang;
  }, [lang, i18n, navigate]);

  return <Outlet />;
};

export default LanguageLayout;
